module.exports = __webpack_public_path__ + "static/img/0008.df4c841.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/usdt2/0008.png
// module id = 6ciI
// module chunks = 1